import { render, staticRenderFns } from "./HelloBackground.vue?vue&type=template&id=bc4e6a3c&scoped=true&"
import script from "./HelloBackground.vue?vue&type=script&lang=js&"
export * from "./HelloBackground.vue?vue&type=script&lang=js&"
import style0 from "./HelloBackground.vue?vue&type=style&index=0&id=bc4e6a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4e6a3c",
  null
  
)

export default component.exports